import { notifications } from '@mantine/notifications';

export class LayoutStore {
  private loadingCounter: number = 0;
  private storingCounter: number = 0;

  onLoadingIsEnabledChanged: ((isLoading: boolean) => void)[] = [];
  onStoringIsEnabledChanged: ((isLoading: boolean) => void)[] = [];
  onError: (error: string) => void = () => {};
  onSuccess: (message: string) => void = () => {};

  public startLoading = () => {
    this.loadingCounter++;
    if (this.loadingCounter == 1)
      this.onLoadingIsEnabledChanged.forEach((f) => f(true));
    if (this.onError) this.onError('');
  };

  public stopLoading = () => {
    this.loadingCounter--;
    if (this.loadingCounter == 0)
      this.onLoadingIsEnabledChanged.forEach((f) => f(false));
  };

  public startStoring = () => {
    this.storingCounter++;
    if (this.storingCounter == 1)
      this.onStoringIsEnabledChanged.forEach((f) => f(true));
    if (this.onError) this.onError('');
  };

  public stopStoring = () => {
    this.storingCounter--;
    if (this.storingCounter == 0)
      this.onStoringIsEnabledChanged.forEach((f) => f(false));
  };

  public isLoading = () => this.loadingCounter > 0;
  public isStoring = () => this.storingCounter > 0;

  public setError(text: string, title = 'Error') {
    notifications.show({
      withCloseButton: true,
      autoClose: 15000,
      title,
      message: text,
      color: 'red',
      loading: false,
    });
    if (this.onError) this.onError(text);
  }

  public setWarning(message: string, title = 'Warning') {
    notifications.show({
      withCloseButton: true,
      autoClose: 15000,
      title,
      message,
      color: 'yellow',
      loading: false,
    });
  }

  public setSuccess(message: string, title = 'Success') {
    notifications.show({
      withCloseButton: true,
      autoClose: 15000,
      title,
      message: message,
      color: 'green',
      loading: false,
    });
    if (this.onSuccess) this.onSuccess(message);
  }
}

export const LayoutStoreInstance = new LayoutStore();
